import { Injectable } from '@angular/core';

@Injectable()
export class PricingService {
  constructor() {}

  /**
   * Formats the price on the items to a price usable
   * on the frontend that has decimal points
   * @param {price} number
   * @return {formatted price} string
   */
  public formatPrice(price) {
    if (price !== null) {
      let priceStr = price.toString();
      let decimal = '.';
      let position;
      switch (priceStr.length) {
        case 2:
          position = -1;
          break;
        case 3:
          position = 1;
          break;
        case 4:
          position = 2;
          break;
        default:
          break;
      }
      return priceStr.substr(0, position) + decimal + priceStr.substr(position);
    }
  }

  /**
   * Generates totals for the components that are strings
   * @param {totals} object
   * @return {formattedTotals} object
   */
  public generateTotals(totals) {
    const formattedTotals = {
      sub_total: this.formatPrice(totals.sub_total),
      tax: this.formatPrice(totals.tax),
      total: this.formatPrice(totals.total),
    };

    return formattedTotals;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pricing/pricing.service.ts